import { createListenerMiddleware } from '@reduxjs/toolkit';

import { baseApi, invalidateSession } from '@/shared/api';

import { sessionActions } from '../slices/session.slice';

export const invalidateSessionListener = createListenerMiddleware();

const startInvalidateSessionListener =
    invalidateSessionListener.startListening as TypedListening;

startInvalidateSessionListener({
    actionCreator: invalidateSession,
    effect: (_, { dispatch }) => {
        dispatch(sessionActions.clear());
        dispatch(baseApi.util.resetApiState());
    },
});
